/* eslint-disable */
// This file contains all GraphQL subscription operation strings for Amplify v6.
// These are used by the useGraphqlSubscription abstraction hook.

export const onCreateOperationalEntity = /* GraphQL */ `
  subscription OnCreateOperationalEntity($transactionId: String) {
    result: onCreateOperationalEntity(transactionId: $transactionId) {
      transactionId
      id
      sources {
        sourceId
        sourceType
      }
      dbaName
      status
      message
    }
  }
`;
